import {
  CheckCircleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/react/outline';
import React from 'react';
import { createContext } from 'react';
import { toast } from 'react-toastify';

export const AnnouncementContext = createContext<{
  setError: (da: string) => void;
  setSuccess: (da: string) => void;
  setInfo: (da: string) => void;
}>({
  setError: (error: string) => undefined,
  setSuccess: (message: string) => undefined,
  setInfo: (da: string) => undefined,
});

export const AnnouncementProvider = ({
  children,
}: {
  children: JSX.Element;
}) => {
  return (
    <AnnouncementContext.Provider
      value={{
        setError: (err: string) => {
          toast.error(err, {
            icon: () => (
              <div className="w-fit">
                <XCircleIcon className="w-7 h-7 text-alert-red shrink-0" />
              </div>
            ),
          });
        },
        setSuccess: (msg: string) => {
          toast.success(msg, {
            icon: () => (
              <CheckCircleIcon className="w-7 h-7 text-alert-green shrink-0" />
            ),
          });
        },
        setInfo: (msg: string) => {
          toast.info(msg, {
            icon: () => (
              <InformationCircleIcon className="w-7 h-7 text-blueberry shrink-0" />
            ),
          });
        },
      }}
    >
      {children}
    </AnnouncementContext.Provider>
  );
};
